import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles/index'
import Grid from '@material-ui/core/Grid'
import Chip from '@material-ui/core/Chip'
import Company from './components/Company'
import Applicant from './components/Applicant'
import Product from './components/Product'
import MessageList from './components/MessageList'
import Offer from './components/Offer'
import Contract from './components/Contract'

const styles = theme => ({
    root: {
        width: '100%',
        //maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #e0e0e0',
        marginBottom: theme.spacing(2)
    },
    chip: {
        marginLeft: theme.spacing(1),
        //marginBottom: theme.spacing.unit * 1,
        minWidth: 60,
        whiteSpace: 'pre-wrap'
    },
    singleChip: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    confirmedChip: {
        background: '#43a047',
        color: 'white'
    },
    question: {
        fontWeight: 400,
        paddingLeft: 0
    },
    section1: {
        margin: `${theme.spacing(3)}px ${theme.spacing(2)}px`
    },
    section2: {
        margin: theme.spacing(2)
    },
    section3: {
        margin: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`
    },
    titleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(1) + 'px solid ' + theme.palette.primary[500],
        borderBottom: '1px solid #e0e0e0'
    },
    mainTitleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(2) + 'px solid ' + theme.palette.primary[700],
        borderBottom: '1px solid #e0e0e0',
        background: theme.palette.primary[500]
    },
    statusSection: {
        margin: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(1)}px`
    },
    title: {
        fontWeight: 500,
        fontSize: '1.2rem'
    },
    titleInfo: {
        fontWeight: 400,
        fontSize: '1.1rem',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.up(600)]: {
            textAlign: 'right',
            paddingRight: theme.spacing(1) + 'px!important'
        }
    },
    chipWrapper: {
        marginBottom: theme.spacing(1)
    },
    tableCell: {
        padding: `${theme.spacing(1)}px ${theme.spacing(0)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`
    },
    thRowCell: {
        height: 45
    },
    lastRowCell: {
        borderBottom: 'none'
    },
    lastColumnCell: {
        paddingRight: theme.spacing(1) + 'px!important'
    },
    gaugeTitle: {
        textAlign: 'center',
        marginTop: theme.spacing(1)
    },
    statusBlue: {
        background: '#f7f7f7',
        border: '1px solid #e0e0e0',
        marginBottom: -1
    },
    statusText: {
        //color: 'white',
        fontWeight: 500,
        fontSize: '0.9rem'
    },
    tableSection: {
        marginBottom: theme.spacing(1)
    },
    formControl: {
        maxWidth: 75
    },
    leftIcon: {
        marginRight: 10,
        marginLeft: -3
    }
})

class Application extends PureComponent {
    state = {}

    render() {
        const { classes, application, refresh, user } = this.props

        return (
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        {application.product && <Product product={application.product} />}
                        {application.applicant && <Applicant applicant={application.applicant} />}
                        {application.company && <Company company={application.company} />}
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {application.messages && <MessageList messages={application.messages} application={application} refresh={refresh} />}
                        {application.offer && <Offer application={application} refresh={refresh} user={user} />}
                        {false && <Contract contract={[]} />}
                        <div style={{ textAlign: 'left', marginTop: 16 }}>
                            <Chip className={classes.chip + ' ' + classes.confirmedChip} label="Vahvistettu tieto" />
                            <Chip className={classes.chip} label="Käyttäjän syöttämä tieto" />
                        </div>
                    </Grid>
                </Grid>
                {false && (
                    <Grid container spacing={2} align="center" style={{ marginBottom: 24 }}>
                        <Grid item xs={12}>
                            <div style={{ borderTop: '1px solid #e0e0e0', marginTop: 24, paddingTop: 16 }}>
                                <Chip className={classes.chip} label="Käyttäjän syöttämä tieto" />
                                <Chip className={classes.chip + ' ' + classes.confirmedChip} label="Vahvistettu tieto" style={{ marginRight: 16 }} />
                            </div>
                        </Grid>
                    </Grid>
                )}
            </>
        )
    }
}

Application.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Application)
